

export const routes = {
    DEFAULT: "/",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
    EDITPROFILE: "/edit-profile",
    USER_PROFILE: "/user/profile",
    USER_REPORT: "/user/profile/report",
    USER: "/user",
    USER_CREATE_USER: "/user/create-user",
    USER_UPDATE_USER: "/user/update-user/:id",
    USER_VIEW_USER: "/user/view-user/:id",
    SESSION:"/session",
    EDIT_SOP:"/session/editsop/:session_id",
    COMPLETE_SESSION:"/session/completesession",
    UPDATE_SESSION:"/session/editsession/:session_id",
    DELETE_SESSION:"/session/deletesession/:session_id",
    VIEW_SESSION:"/session/viewsession/:session_id",
    CREATE_SESSION:"/session/createsession",
    LUNCH_SESSION:"/lunch-session",
    LIVE_SESSION:"/lunch-session/live-session/:session_id",
    MICE_RECORDING:"/lunch-session/mice",
    SPEAKER_RECORDING:"/lunch-session/speaker",
    GENERATE_QUESTION:"/lunch-session/generate-question",
    CHANGEPASSWORD: "/change-password",
    FORGOTPASSWORD: "/auth/forgot-password",
    RESETPASSWORD:"/auth/reset-password",
    QUESTION:"/question",
    FAQ:"/audio_management",
    VIDEO:"/video_management",
    CREATE_VIDEO_Sop:"/video_management/create_video_sop",
    MERGE_VIDEO:"/video_management/merge_video_sop",
    KEY_VALUE:"/keyValue",
    ERROR: "*",
};